<login-home-navigation></login-home-navigation>

<section class="buyer-hero">

    <div class="container">

        <span class="page-badge">
            Buyer Benefits
        </span>

        <h1>
            Find Qualified Manufacturing Suppliers Faster
        </h1>

        <p>
            Reduce supplier search time, discover verified manufacturers,
            compare quotations, and manage sourcing requirements through GYV.
        </p>

        <a routerLink="/login/signup" class="primary-btn">
            Submit Your Requirement
        </a>

    </div>

</section>

<section class="buyer-benefits">

    <div class="container">

        <div class="section-header">

            <h2>Why Buyers Choose GYV</h2>

            <p>
                GYV simplifies supplier identification and helps procurement teams
                connect with qualified manufacturing partners.
            </p>

        </div>

        <div class="row">

            <div class="col-lg-3 col-md-6">
                <div class="benefit-card">
                    <i class="fa fa-search"></i>
                    <h4>Supplier Discovery</h4>
                    <p>Find manufacturers across multiple industrial categories.</p>
                </div>
            </div>

            <div class="col-lg-3 col-md-6">
                <div class="benefit-card">
                    <i class="fa fa-check-circle"></i>
                    <h4>Verified Vendors</h4>
                    <p>Connect with suppliers based on capabilities and processes.</p>
                </div>
            </div>

            <div class="col-lg-3 col-md-6">
                <div class="benefit-card">
                    <i class="fa fa-file-text"></i>
                    <h4>RFQ Management</h4>
                    <p>Share drawings and sourcing requirements easily.</p>
                </div>
            </div>

            <div class="col-lg-3 col-md-6">
                <div class="benefit-card">
                    <i class="fa fa-line-chart"></i>
                    <h4>Faster Procurement</h4>
                    <p>Reduce sourcing effort and accelerate vendor development.</p>
                </div>
            </div>

        </div>

    </div>

</section>

<section class="buyer-process">

    <div class="container">

        <div class="section-header">

            <h2>How It Works</h2>

        </div>

        <div class="row">

            <div class="col-lg-4">

                <div class="step-card">

                    <div class="step-number">1</div>

                    <h4>Submit Requirement</h4>

                    <p>
                        Share your RFQ, drawings, BOM or sourcing requirement.
                    </p>

                </div>

            </div>

            <div class="col-lg-4">

                <div class="step-card">

                    <div class="step-number">2</div>

                    <h4>Supplier Matching</h4>

                    <p>
                        Receive recommendations based on manufacturing capability.
                    </p>

                </div>

            </div>

            <div class="col-lg-4">

                <div class="step-card">

                    <div class="step-number">3</div>

                    <h4>Connect & Source</h4>

                    <p>
                        Compare suppliers and start discussions.
                    </p>

                </div>

            </div>

        </div>

    </div>

</section>

<section class="buyer-features">

    <div class="container">

        <div class="section-header">

            <h2>What You Get</h2>

        </div>

        <div class="row">

            <div class="col-lg-6">

                <ul class="feature-list">
                    <li>Supplier Identification Support</li>
                    <li>RFQ Publishing</li>
                    <li>Quotation Tracking</li>
                    <li>Supplier Assessment</li>
                </ul>

            </div>

            <div class="col-lg-6">

                <ul class="feature-list">
                    <li>Digital NDA Support</li>
                    <li>Vendor Comparison</li>
                    <li>Supplier Tracking</li>
                    <li>Manufacturing Network Access</li>
                </ul>

            </div>

        </div>

    </div>

</section>

<section class="buyer-cta">

    <div class="container">

        <h2>
            Ready to Find Manufacturing Suppliers?
        </h2>

        <p>
            Connect with qualified manufacturers across India and simplify your sourcing process.
        </p>

        <a routerLink="/login/signup" class="primary-btn">
            Submit Your Requirement
        </a>

    </div>

</section>

<login-home-footer></login-home-footer>